// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__tBBFE","large":"styles_large__3Td2H"};